var lib_core           = require("lib-core");

var SymbolSettingsView = function(model, stateMachine, parentView, configuration) {
    ui_extensions.SettingsView.apply(this, arguments);
};

if(typeof window !== 'undefined') {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(SymbolSettingsView, ui_extensions.SettingsView);
}

module.exports = SymbolSettingsView;
